module.exports = __webpack_public_path__ + "img/4-2.822ea30c.svg";